/**
 * Centralized styles for Employee Form components
 * All class names used across the form should be defined here
 */

export const employeeFormStyles = {
  // Container styles
  container: 'flex flex-col gap-6 md:rounded-lg md:border md:border-border md:p-6',
  containerCards: 'flex flex-col gap-6 md:rounded-lg md:border md:border-border md:p-6',

  // Form layout
  form: 'flex flex-col gap-6',
  inputGroup: 'flex flex-col 1',
  gridGroup: 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4',
  field: 'flex flex-col 1 gap-1',

  // Validation states
  required: 'text-destructive',
  fieldError: 'border-destructive',
  errorMessage: 'text-sm text-destructive',

  // Tabs
  tabsContainer: 'flex flex-col gap-4',
  tabsWrapper: 'bg-muted p-1.5 rounded-md inline-flex w-fit',
  tab: {
    base: 'px-3 py-1.5 text-sm font-medium rounded-xs transition-colors',
    active: 'bg-background text-foreground shadow-xs',
    inactive: 'bg-transparent text-muted-foreground hover:text-foreground',
  },

  // Headers
  header: {
    wrapper: 'p-6',
    title: 'text-base font-semibold text-foreground mb-1',
    cardTitle: 'text-lg font-semibold text-foreground mb-1',
    description: 'text-sm text-muted-foreground',
  },

  // Layout helpers
  row: 'flex items-center justify-between',
  rowText: 'flex flex-col gap-1',

  // Stores section
  storesGrid: 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-2 gap-x-8 justify-items-center items-center ml-6',
  storeItem: 'flex items-start justify-start gap-2 pt-2 w-full',

  // Notifications section
  checkboxList: 'flex flex-col gap-4',
  modulesHeader: {
    wrapper: 'flex items-start gap-3 mb-4',
    icon: 'size-5 text-foreground mt-0.5',
    textWrapper: 'flex flex-col gap-0',
    title: 'text-sm font-medium text-foreground',
    description: 'text-sm text-muted-foreground',
  },

  // Misc
  todoMessage: 'text-sm text-muted-foreground',
  hiddenButton: 'hidden',

  // Tabs
  tabsList: 'bg-muted p-1.5 rounded-md inline-flex w-fit h-auto',
  tabsTrigger:
    'px-3 py-1.5 text-sm font-medium rounded-xs data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-xs',
  tabsContent: 'flex flex-col gap-4',
} as const;

/** Shorthand alias for cleaner imports */
export const styles = employeeFormStyles;
